import { AiAssistantMessage, QuestionInput } from '@cureskin/api-client-rn';

export { AiAssistantMessage } from '@cureskin/api-client-rn';

export type AiAssistantChatInput = QuestionInput;

export const OPEN_AI_ASSISTANT_EVENT = 'OPEN_AI_ASSISTANT_CHAT';

export type AiAssistantErrorState = 'none' | 'retryable' | 'stale';

export interface AiAssistantChatState {
  messages: AiAssistantMessage[];
  isThinking: boolean;
  latestMessage: AiAssistantMessage | null;
  isLoadingOldMessages: boolean;
  errorState: AiAssistantErrorState;
}

export interface AiAssistantPaginationState {
  hasMore: boolean;
  pageSize: number;
}
